import { render, staticRenderFns } from "./StatForm.vue?vue&type=template&id=a8d785ac&"
import script from "./StatForm.vue?vue&type=script&lang=js&"
export * from "./StatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports